<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div>
              <div v-if="response_info.Data.length > 0">
                <div
                  class="card-header card-header-primary negative blue-grad w-50"
                >
                  <h4>
                    {{ $t("message.find_partner.court_notice_info")
                    }}<span v-if="doc_additional && doc_additional.request"
                      >: {{ doc_additional.request }}</span
                    >
                  </h4>
                </div>
                <br />
                <b-table
                  :fixed="true"
                  :fields="court_notice_list_fields"
                  :items="response_info.Data"
                >
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {
      current_tab: 0,
      response_info: {},
      service_info: {},
      service_info_objects: {},
      keyWord: "",
      searchComplete: false,
      court_notice_list_fields: [
        {
          key: "Id",
          label: this.$t("message.find_partner.court_notice_Id"),
          thStyle: { width: "10%" },
        },
        {
          key: "CaseNo",
          label: this.$t("message.find_partner.court_notice_CaseNo"),
        },
        {
          key: "CaseReason",
          label: this.$t("message.find_partner.court_notice_CaseReason"),
        },
        {
          key: "Category",
          label: this.$t("message.find_partner.court_notice_Category"),
        },
        {
          key: "Court",
          label: this.$t("message.find_partner.court_notice_Court"),
        },
        {
          key: "PublishDate",
          label: this.$t("message.find_partner.court_notice_PublishDate"),
        },
        {
          key: "ProsecutorList",
          label: this.$t("message.find_partner.court_notice_ProcecutorList"),
        },
        {
          key: "DefendantList",
          label: this.$t("message.find_partner.court_notice_DefendantList"),
        },
      ],
    };
  },
  mounted() {
    //this.service_info = Object.entries(this.doc);
    this.response_info = this.doc;
    //this.service_info_objects = this.service_info.filter(item => typeof item[1] === 'object' && item[1] !== null && !_.isArray(item[1]));
    //this.service_info = this.service_info.filter(item => typeof item[1] !== 'object' && !_.isArray(item[1]));
    setTimeout(() => {
      this.$root.$emit("print-pdf", {
        signature: "",
        type: "court-info-service-cn",
      });
    }, 2000);
  },
  computed: {},
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    // searchCompanyCourtInfo() {
    //     axios.get(window.base+'/admin/GetBillingServiceInfo?code=930')
    // 		.then(response=>{
    // 			this.$bvModal.msgBoxConfirm(this.$t('message.find_partner.cn_company_info_check_alert') + ' ' + response.data.billing_service_price + ' ' + response.data.billing_service_cur, {
    // 				title: this.$t('message.confirm'),
    // 				size: 'sm',
    // 				buttonSize: 'sm',
    // 				okVariant: 'danger',
    // 				okTitle: this.$t('message.yes'),
    // 				cancelTitle: this.$t('message.no'),
    // 				footerClass: 'p-2',
    // 				hideHeaderClose: false,
    // 				centered: true
    // 				}).then(value => {
    // 					if(value){
    // 						axios.get(window.base + '/library/openAPICourtMock?keyWord=' + this.keyWord).then(response => {
    //                         this.searchComplete = true;
    //                         this.service_info = Object.entries(response.data.Result);
    //                         this.response_info = response.data.Result;
    //                         this.service_info_objects = this.service_info.filter(item => typeof item[1] === 'object' && item[1] !== null && !_.isArray(item[1]));
    //                         if (this.response_info.VerifyResult == 1 && this.response_info.Data.length > 0) {
    //                             if (this.response_info.Data.ProsecutorList.length > 0) {
    //                                 this.response_info.Data.ProsecutorList = this.response_info.Data.ProsecutorList.map(value => {
    //                                         return value.Name
    //                                 }).join(",");

    //                             }
    //                             if (this.response_info.Data.DefendantList.length > 0) {
    //                                 this.response_info.Data.DefendantList = this.response_info.Data.DefendantList.map(value => {
    //                                         return value.Name
    //                                 }).join(",");
    //                             }
    //                         }
    //                         console.log('service info objects');
    //                         console.log(this.service_info_objects);

    //                         this.service_info = this.service_info.filter(item => typeof item[1] !== 'object' && !_.isArray(item[1]));

    //                         console.log('service info');
    //                         console.log(this.service_info);
    //                     })
    // 					}
    // 				})
    // 		})

    // }
  },
};
</script>
